import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { FormCreatorService } from '../../../../services/form-creator.service';
import Swal from 'sweetalert2';
import { Spinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { UntypedFormControl, FormGroup } from '@angular/forms';
import { ConfigService } from '../../../../services/config.service';
import { LoginService } from "../../../../services/login.service";
import { PasswordService } from "../../../../services/password.service";
import { AccountSelectorPopupComponent } from "../../../template/account-selector-popup/account-selector-popup.component";
import { MatDialog } from "@angular/material/dialog";



@Component({
  selector: 'app-auto-inscription',
  templateUrl: './auto-inscription.component.html',
  styleUrls: ['./auto-inscription.component.css'],
  standalone: false
})
export class AutoInscriptionComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);
  passwordIsValid = false;
  // tslint:disable-next-line:variable-name
  public forms: any;
  // tslint:disable-next-line:variable-name
  public group_id: any;
  public countries: any;
  // tslint:disable-next-line:variable-name
  public group_id_check: any;
  loadingAdd: boolean;
  showSSOMEssage: boolean;
  // tslint:disable-next-line:max-line-length variable-name
  public profile_id = parseInt(localStorage.getItem('profile_id'));

  login = new UntypedFormControl();
  firstname = new UntypedFormControl();
  lastname = new UntypedFormControl();
  password = new UntypedFormControl();
  email = new UntypedFormControl();
  // tslint:disable-next-line:variable-name
  confirm_password = new UntypedFormControl();
  // tslint:disable-next-line:variable-name
  public nlmk_user = {
    login: null,
    firstname: null,
    lastname: null,
    password: null,
    confirm_password: null,
    start_date: null,
    end_date: null,
    site_id: null,
    email: null,
    profile_id: 3,
    custom_level_id: 0,
    group_id: null,
    field20_details: {
      cid: null,
      registrenational: null,
      // nationalite: null,
      // sexe: null,
      // travailleuretranger: null,
      datenaissance: null,
      // gsm: null,
      // plaquevehicule: null,
      employeur: null,
      // employeurtva: null,
      // fonction: null,
      limosa: null,
      e101: null,
      // brevets: [],
      site_user: null,
      manageremail: null,
      unite_service: null,
      numero_installation: null,
      service: null,
    }
  };
  // tslint:disable-next-line:max-line-length variable-name
  public url_details: string;
  // tslint:disable-next-line:variable-name
  public showInfo: boolean = false;
  public show_nlk_form: boolean = false;
  public show_auto_inscription_form: boolean = false;
  public show_auto_inscription_form_BASF: boolean = false;
  public show_auto_inscription_form_BASF_Lyon: boolean = false;
  public show_auto_inscription_form_LVMH: boolean = false;
  public show_auto_inscription_form_PIMENT: boolean = false;
  public show_auto_inscription_form_Forgital: boolean = false;
  public show_form_home_security: boolean = false;
  public show_auto_inscription_form_ORIL_FR: boolean = false;
  public show_auto_inscription_form_ORIL_EN: boolean = false;
  public show_form_AS_SACLAY: boolean = false;
  public show_form_AS_FONTENAY: boolean = false;

  public afficherInfoBulle: boolean = false;
  public isPasswordInvalid: boolean = false;

  // tslint:disable-next-line:max-line-length
  public token: any;
  // tslint:disable-next-line:max-line-length variable-name
  public content_form: any;
  // tslint:disable-next-line:max-line-length variable-name
  public form_site_id: any;
  // tslint:disable-next-line:max-line-length
  showLimosaAndE101 = false;
  // tslint:disable-next-line:max-line-length
  choose: any;
  public entityType = this.configService.entityType;

  // tslint:disable-next-line:max-line-length variable-name radix
  constructor(private loginService: LoginService, private configService: ConfigService, private spinner: NgxSpinnerService, public meta: Meta, public pageTitle: Title, private activatedRoute: ActivatedRoute, private router: Router, private userService: UserService, private formCreatorService: FormCreatorService, private passwordService: PasswordService, private dialog: MatDialog) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params.token;
      this.group_id_check = params.group;
    });
  }

  ngOnInit() {
    this.get_form(this.token);
    this.get_country();
  }

  getCurrentDate() {
    // tslint:disable-next-line:prefer-const
    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return dd + '-' + mm + '-' + yyyy;
  }

  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }

    // Vérifier s'il y a des espaces
    if (email.includes(' ')) {
      return false;
    }

    // Expression régulière pour valider le format email
    const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/;

    // Vérifier le format de base
    if (!emailRegex.test(email)) {
      return false;
    }

    // Vérifications supplémentaires
    const parts = email.split('@');
    if (parts.length !== 2) {
      return false;
    }

    const [localPart, domainPart] = parts;

    // Vérifier la partie locale (avant @)
    if (localPart.length === 0 || localPart.length > 64) {
      return false;
    }

    // Ne doit pas commencer ou finir par un point
    if (localPart.startsWith('.') || localPart.endsWith('.')) {
      return false;
    }

    // Ne doit pas avoir deux points consécutifs
    if (localPart.includes('..')) {
      return false;
    }

    // Vérifier la partie domaine (après @)
    if (domainPart.length === 0 || domainPart.length > 255) {
      return false;
    }

    // Le domaine ne doit pas commencer ou finir par un tiret
    if (domainPart.startsWith('-') || domainPart.endsWith('-')) {
      return false;
    }

    return true;
  }

  get_form(token) {
    this.formCreatorService.getOneForm(token)
      .subscribe(res => {
        this.group_id = res.data.group_id;
        this.form_site_id = res.data.form_site_id;
        this.forms = res.data;
        if (this.entityType == 'IP') {
          if (res.success === false) {
            this.router.navigate(['/']);
            return false;
          } else {
            this.form_site_id = res.data.site_id;
            if (res.data.site_id === 23) {
              this.show_nlk_form = true;
            } else {
              this.show_nlk_form = false;
              this.form_site_id = res.data.site_id;
              if (res.data.content !== '') {
                this.content_form = JSON.parse(res.data.content);
              }
            }
          }
        } else {
          if (res.success === false) {
            this.router.navigate(['/']);
            return false;
          } else {
            this.form_site_id = res.data.site_id;
            if (res.data.site_id === 23) {
              this.show_nlk_form = true;
            } else if (res.data.site_id === 58) {
              if (this.group_id == 3019) {
                this.show_auto_inscription_form_BASF = true;
              } else if (this.group_id == 3668) {
                this.show_auto_inscription_form_BASF_Lyon = true;
              }
            } else if (res.data.site_id === 22) {
              // Formulaire LVMH
              this.show_auto_inscription_form_LVMH = true;
            } else if (res.data.site_id === 11) {
              this.show_form_home_security = true;
            } else if (res.data.site_id === 3) {
              //ORIL form FR
              if (this.group_id === 3471) {
                this.show_form_AS_SACLAY = true;
              }
              //ORIL form EN
              else {
                this.show_form_AS_FONTENAY = true;
              }
            } else if (res.data.site_id === 48) {
              //ORIL form FR
              if (this.group_id === 2333) {
                this.show_auto_inscription_form_ORIL_FR = true;
              }
              //ORIL form EN
              else {
                this.show_auto_inscription_form_ORIL_EN = true;
              }
            } else if (res.data.site_id === 69) {
              //PIMENT form
              this.show_auto_inscription_form_PIMENT = true;
            } else if (res.data.site_id === 64) {
              //PIMENT form
              this.show_auto_inscription_form_Forgital = true;
            }

            else {
              this.show_auto_inscription_form = true;
              this.form_site_id = res.data.site_id;
              if (res.data.content !== '') {
                this.content_form = JSON.parse(res.data.content);
              }
            }
          }
        }
      }, (err) => {
        this.spinner.hide();
        if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
          (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.invalidEmail'),
            text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
            confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.serverError'),
            text: this.runtimeTranslate.instant('alerts.tryLater'),
          });
        }
        console.log(err);
      });
  }

  get_country() {
    this.formCreatorService.getCountryList()
      .subscribe(res => {
        this.countries = res.data;
      }, (err) => {
        this.spinner.hide();
        if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
          (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.invalidEmail'),
            text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
            confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.serverError'),
            text: this.runtimeTranslate.instant('alerts.tryLater'),
          });
        }
        console.log(err);
      });
  }

  auto_form_registration_nlmk() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null || this.nlmk_user.lastname == undefined || this.nlmk_user.lastname == ''
      || this.nlmk_user.firstname === null || this.nlmk_user.firstname == undefined || this.nlmk_user.firstname == ''
      || this.nlmk_user.field20_details.datenaissance === null || this.nlmk_user.field20_details.datenaissance == undefined || this.nlmk_user.field20_details.datenaissance == ''
      || this.nlmk_user.field20_details.employeur === null || this.nlmk_user.field20_details.employeur == undefined || this.nlmk_user.field20_details.employeur == ''
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (this.nlmk_user.email && !this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else {
      const body = {
        login: this.nlmk_user.login,
        firstname: this.nlmk_user.firstname,
        lastname: this.nlmk_user.lastname,
        password: this.nlmk_user.password,
        start_date: this.getCurrentDate(),
        end_date: null,
        site_id: this.form_site_id,
        email: this.nlmk_user.email,
        profile_id: 3,
        custom_level_id: 0,
        group_id: this.group_id,
        group_id_check: this.group_id_check,
        token: this.token,
        field20_details: {
          cid: this.nlmk_user.field20_details.cid,
          registrenational: this.nlmk_user.field20_details.registrenational,
          datenaissance: this.nlmk_user.field20_details.datenaissance,
          employeur: this.nlmk_user.field20_details.employeur,
          limosa: this.nlmk_user.field20_details.limosa,
          e101: this.nlmk_user.field20_details.e101,
          site_user: this.nlmk_user.field20_details.site_user,
          group_id: this.group_id,
        }
      };
      this.formCreatorService.createFormNlmk(body)
        .subscribe(res => {
          if (res.success === true) {
            this.spinner.hide();
            this.nlmk_user.login = '';
            this.nlmk_user.firstname = '';
            this.nlmk_user.lastname = '';
            this.nlmk_user.password = '';
            this.nlmk_user.start_date = '';
            this.nlmk_user.end_date = '';
            this.nlmk_user.site_id = '';
            this.nlmk_user.email = '';
            // @ts-ignore
            this.nlmk_user.profile_id = '';
            // @ts-ignore
            this.nlmk_user.custom_level_id = '';
            this.nlmk_user.field20_details.cid = '';
            this.nlmk_user.field20_details.registrenational = '';
            this.nlmk_user.field20_details.datenaissance = '';
            this.nlmk_user.field20_details.employeur = '';
            this.sso_certikap_new(res.login);
          } else {
            this.spinner.hide();
            // Vérifier si l'erreur concerne le domaine email
            if (res.message && res.message.includes('domaine de l\'email')) {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.error'),
                text: res.message || this.runtimeTranslate.instant('alerts.tryAgain')
              });
            }
          }
        }, (err) => {
          this.spinner.hide();
          if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
            (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.invalidEmail'),
              text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
              confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.serverError'),
              text: this.runtimeTranslate.instant('alerts.tryLater'),
            });
          }
          console.log(err);
        });
    }
  }

  makeRandomPassword() {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;\'[]\=-)(*&^%$#@!~`';
    const lengthOfCode = 40;
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }

  isStranger(event) {
    this.choose = event.target.value;
    if (this.choose === 1) {
      this.showLimosaAndE101 = true;
    } else {
      this.showLimosaAndE101 = false;
    }

  }

  sso_certikap() {
    this.showSSOMEssage = true;
    this.spinner.show();
    const body = {
      // ssoKey : 'h-kaptitude'
      ssoKey: this.form_site_id === 23 ? this.nlmk_user.login : this.login.value
    };
    this.formCreatorService.sso_connexion_form_redirection(body)
      .subscribe(res => {
        // @ts-ignore
        if (res.sso_data === '') {
          this.spinner.hide();
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.oops'),
            text: this.runtimeTranslate.instant('messages.unknownTalensoft'),
            footer: '<a href>Equipe Kaptitude</a>'
          });
          return false;
        }
        this.spinner.hide();
        this.showSSOMEssage = false;
        // @ts-ignore
        window.location.replace(this.configService.ELMS_url + 'sso.php?skey=' + res.sso_data);

      }, (err) => {
        this.spinner.hide();
        if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
          (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.invalidEmail'),
            text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
            confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.serverError'),
            text: this.runtimeTranslate.instant('alerts.tryLater'),
          });
        }
        console.log(err);
      });
  }

  sso_certikap_nlmk(login) {
    this.showSSOMEssage = true;
    this.spinner.show();
    const body = {
      // ssoKey : 'h-kaptitude'
      ssoKey: login
    };
    this.formCreatorService.sso_connexion_form_redirection(body)
      .subscribe(res => {
        // @ts-ignore
        if (res.sso_data === '') {
          this.spinner.hide();
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.oops'),
            text: this.runtimeTranslate.instant('messages.unknownTalensoft'),
            footer: '<a href>Equipe Kaptitude</a>'
          });
          return false;
        }
        this.spinner.hide();
        this.showSSOMEssage = false;
        // @ts-ignore
        window.location.replace(this.configService.ELMS_url + 'sso.php?skey=' + res.sso_data);

      }, (err) => {
        this.spinner.hide();
        if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
          (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.invalidEmail'),
            text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
            confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.serverError'),
            text: this.runtimeTranslate.instant('alerts.tryLater'),
          });
        }
        console.log(err);
      });
  }

  auto_form_registration_other() {
    this.spinner.show();
    if (typeof this.content_form !== 'undefined') {
      // tslint:disable-next-line:variable-name
      for (const form_element of this.content_form) {
        // tslint:disable-next-line:max-line-length
        if (form_element.is_required === 1
          && (document.getElementById(form_element.ng_model_name) as HTMLInputElement).value.length === 0) {
          // tslint:disable-next-line:max-line-length
          // if () {
          this.spinner.hide();
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.oops'),
            text: this.runtimeTranslate.instant('alerts.requiredInputs')
          });
          this.loadingAdd = false;
          return;
        }
      }
      if (this.lastname.value === null
        || this.lastname.value.length === 0
        || this.password.value === null
        || this.password.value.length === 0
        || this.login.value === null
        || this.login.value.length === 0
        || this.email.value === null
        || this.email.value.length === 0
        || this.firstname.value === null
        || this.firstname.value.length === 0) {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.runtimeTranslate.instant('alerts.oops'),
          text: this.runtimeTranslate.instant('alerts.requiredInputs')
        });
        this.loadingAdd = false;
        return false;
      } else if (this.password.value !== this.confirm_password.value) {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.runtimeTranslate.instant('alerts.oops'),
          text: this.runtimeTranslate.instant('alerts.passwordMismatch')
        });
        this.loadingAdd = false;
        return false;
      } else if (!this.passwordService.verifyPassword(this.password.value)) {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.runtimeTranslate.instant('alerts.oops'),
          text: this.runtimeTranslate.instant('auth.passwordRules')
        });
        this.isPasswordInvalid = true;
      } else if (!this.isValidEmail(this.email.value)) {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
          text: this.runtimeTranslate.instant('alerts.enterValidEmail')
        });
      }
      else {
        const body = {
          // (document.getElementById('societe') as HTMLInputElement).value
          login: this.login.value,
          firstname: this.firstname.value,
          lastname: this.lastname.value,
          password: this.password.value,
          start_date: this.getCurrentDate(),
          end_date: null,
          site_id: this.form_site_id,
          email: this.email.value,
          profile_id: 3,
          custom_level_id: 0,
          group_id: this.group_id,
          group_id_check: this.group_id_check,
          token: this.token,
          other_fields: {
            // tslint:disable-next-line:max-line-length
            service: (document.getElementById('service') as HTMLInputElement) ? (document.getElementById('service') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            rppsadeli: (document.getElementById('rppsadeli') as HTMLInputElement) ? (document.getElementById('rppsadeli') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            matricule: (document.getElementById('matricule') as HTMLInputElement) ? (document.getElementById('matricule') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            societe: (document.getElementById('societe') as HTMLInputElement) ? (document.getElementById('societe') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            ville: (document.getElementById('ville') as HTMLInputElement) ? (document.getElementById('ville') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            managernom: (document.getElementById('managernom') as HTMLInputElement) ? (document.getElementById('managernom') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            managerprenom: (document.getElementById('managerprenom') as HTMLInputElement) ? (document.getElementById('managerprenom') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            manageremail: (document.getElementById('manageremail') as HTMLInputElement) ? (document.getElementById('manageremail') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            statusprofession: (document.getElementById('statusprofession') as HTMLInputElement) ? (document.getElementById('statusprofession') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            fonction: (document.getElementById('fonction') as HTMLInputElement) ? (document.getElementById('fonction') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            date_de_naissance: (document.getElementById('date_de_naissance') as HTMLInputElement) ? (document.getElementById('date_de_naissance') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            adresse1: (document.getElementById('adresse1') as HTMLInputElement) ? (document.getElementById('adresse1') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            adresse2: (document.getElementById('adresse2') as HTMLInputElement) ? (document.getElementById('adresse2') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            codepostal: (document.getElementById('codepostal') as HTMLInputElement) ? (document.getElementById('codepostal') as HTMLInputElement).value : '',
            pays: (document.getElementById('pays') as HTMLInputElement) ? (document.getElementById('pays') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            unite_service: (document.getElementById('unite_service') as HTMLInputElement) ? (document.getElementById('unite_service') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            mode_exercice_dominant: (document.getElementById('mode_exercice_dominant') as HTMLInputElement) ? (document.getElementById('mode_exercice_dominant') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            numero_installation: (document.getElementById('numero_installation') as HTMLInputElement) ? (document.getElementById('numero_installation') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            nom_naissance_diferent: (document.getElementById('nom_naissance_diferent') as HTMLInputElement) ? (document.getElementById('nom_naissance_diferent') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            profession: (document.getElementById('profession') as HTMLInputElement) ? (document.getElementById('profession') as HTMLInputElement).value : '',
          }
        };
        this.formCreatorService.createFormAutoInscription(body)
          .subscribe(res => {
            if (res.success === true) {
              this.spinner.hide();
              Swal.fire({
                title: this.runtimeTranslate.instant('alerts.congratulations'),
                text: res.message,
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.runtimeTranslate.instant('auth.login'),
                cancelButtonText: this.runtimeTranslate.instant('common.cancel')
              }).then((result) => {
                if (result.isConfirmed) {
                  this.sso_certikap();
                }
              });
            } else {
              this.spinner.hide();
              // Vérifier si l'erreur concerne le domaine email
              if (res.message && res.message.includes('domaine de l\'email')) {
                Swal.fire({
                  icon: 'error',
                  title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                  text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                  confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
                });
              } else {
                Swal.fire({
                  icon: 'error',
                  title: this.runtimeTranslate.instant('alerts.error'),
                  text: res.message,
                });
              }
            }
          }, (err) => {
            this.spinner.hide();
            // Gestion des erreurs serveur (400, 500, etc.)
            if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
              (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.serverError'),
                text: this.runtimeTranslate.instant('alerts.tryLater'),
              });
            }
            console.log(err);
          });
      }
    } else {
      // Field de base
      if (this.lastname.value === null
        || this.password.value === null
        || this.login.value === null
        || this.email.value === null
        || this.firstname.value === null) {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.runtimeTranslate.instant('alerts.oops'),
          text: this.runtimeTranslate.instant('alerts.requiredInputs')
        });
        this.loadingAdd = false;
        return false;
      }
      else if (this.password.value !== this.confirm_password.value) {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.runtimeTranslate.instant('alerts.oops'),
          text: this.runtimeTranslate.instant('alerts.passwordMismatch')
        });
        this.loadingAdd = false;
        return false;
      } else if (!this.passwordService.verifyPassword(this.password.value)) {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.runtimeTranslate.instant('alerts.oops'),
          text: this.runtimeTranslate.instant('auth.passwordRules')
        });
        this.isPasswordInvalid = true;
      } else if (!this.isValidEmail(this.email.value)) {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
          text: this.runtimeTranslate.instant('alerts.enterValidEmail')
        });
      }
      else {
        const body = {
          // (document.getElementById('societe') as HTMLInputElement).value
          login: this.login.value,
          firstname: this.firstname.value,
          lastname: this.lastname.value,
          password: this.password.value,
          start_date: this.getCurrentDate(),
          end_date: null,
          site_id: this.form_site_id,
          email: this.email.value,
          profile_id: 3,
          custom_level_id: 0,
          group_id: this.group_id,
          group_id_check: this.group_id_check,
          token: this.token,
          other_fields: {
            // tslint:disable-next-line:max-line-length
            service: (document.getElementById('service') as HTMLInputElement) ? (document.getElementById('service') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            rppsadeli: (document.getElementById('rppsadeli') as HTMLInputElement) ? (document.getElementById('rppsadeli') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            matricule: (document.getElementById('matricule') as HTMLInputElement) ? (document.getElementById('matricule') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            societe: (document.getElementById('societe') as HTMLInputElement) ? (document.getElementById('societe') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            ville: (document.getElementById('ville') as HTMLInputElement) ? (document.getElementById('ville') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            managernom: (document.getElementById('managernom') as HTMLInputElement) ? (document.getElementById('managernom') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            managerprenom: (document.getElementById('managerprenom') as HTMLInputElement) ? (document.getElementById('managerprenom') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            manageremail: (document.getElementById('manageremail') as HTMLInputElement) ? (document.getElementById('manageremail') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            statusprofession: (document.getElementById('statusprofession') as HTMLInputElement) ? (document.getElementById('manageremail') as HTMLInputElement).value : '',
            // tslint:disable-next-line:max-line-length
            fonction: (document.getElementById('fonction') as HTMLInputElement) ? (document.getElementById('fonction') as HTMLInputElement).value : '',
          }
        };
        this.formCreatorService.createFormAutoInscription(body)
          .subscribe(res => {
            console.log("ici", res);
            if (res.success === true) {
              this.spinner.hide();
              Swal.fire({
                title: this.runtimeTranslate.instant('alerts.congratulations'),
                text: res.message,
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.runtimeTranslate.instant('auth.login'),
                cancelButtonText: this.runtimeTranslate.instant('common.cancel')
              }).then((result) => {
                if (result.isConfirmed) {
                  this.sso_certikap();
                }
              });
            } else {
              this.spinner.hide();
              // Vérifier si l'erreur concerne le domaine email
              if (res.message && res.message.includes('domaine de l\'email')) {
                Swal.fire({
                  icon: 'error',
                  title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                  text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                  confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
                });
              } else {
                Swal.fire({
                  icon: 'error',
                  title: this.runtimeTranslate.instant('alerts.error'),
                  text: res.message,
                });
              }
            }
          }, (err) => {
            this.spinner.hide();
            // Gestion des erreurs serveur (400, 500, etc.)
            if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
              (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.serverError'),
                text: this.runtimeTranslate.instant('alerts.tryLater'),
              });
            }
            console.log(err);
          });
      }
    }
  }

  sso_certikap_new(login) {
    this.spinner.show();
    const body = {
      ssoKey: login
    };
    this.formCreatorService.sso_connexion_form_redirection(body)
      .subscribe(res => {
        // @ts-ignore
        if (res.sso_data === '') {
          this.spinner.hide();
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.oops'),
            text: this.runtimeTranslate.instant('alerts.noContentAccess'),
            footer: '<a href>Equipe Kaptitude</a>'
          });

          return false;
        } else {
          // @ts-ignore
          setTimeout(() => {
            this.configService.redirectTools();
          }, 500); // délai de 2000 ms (2 secondes)
          setTimeout(() => {
            this.sso_login_to_certikap(login);
          }, 1000); // délai de 2000 ms (2 secondes)
        }
      }, (err) => {
        this.spinner.hide();
        if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
          (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.invalidEmail'),
            text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
            confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.serverError'),
            text: this.runtimeTranslate.instant('alerts.tryLater'),
          });
        }
        console.log(err);
      });
  }

  sso_login_to_certikap(login) {
    this.spinner.show();
    const body = {
      login: login,
    };
    this.loginService.connexion_with_login(body)
      .subscribe(res => {
        this.spinner.hide();
        // @ts-ignore
        if (res.status === 'multicomptes') {
          // @ts-ignore
          this.openMulticomptesDialog(res.multicomptes);
        }
        // @ts-ignore
        if (res.status === 'success') {
          this.loginService.logout_take_in_hand();
          localStorage.removeItem('currentUser');
          localStorage.removeItem('tokenCurrentConnected');
          // @ts-ignore
          localStorage.setItem('currentUser', JSON.stringify(res));
          // @ts-ignore
          localStorage.setItem('tokenCurrentConnected', JSON.stringify(res.token));
          // @ts-ignore
          this.loginService.currentUserSubject.next(res);
          // @ts-ignore
          localStorage.setItem('profile_id', res.profile_id);
          // @ts-ignore
          localStorage.setItem('site_id', res.site_id);
          // @ts-ignore
          this.configService.redirectTools();
          window.location.reload();
          return res;

        } else {
          this.router.navigate(['/']);
          this.spinner.hide();
        }
      }, (err) => {
        this.router.navigate(['/']);
        this.spinner.hide();
        if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
          (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.invalidEmail'),
            text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
            confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.serverError'),
            text: this.runtimeTranslate.instant('alerts.tryLater'),
          });
        }
        console.log(err);
      });
  }

  auto_form_registration_basf() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.field20_details.employeur === null
      || this.nlmk_user.email === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else {
      const body = {
        login: this.nlmk_user.login,
        firstname: this.nlmk_user.firstname,
        lastname: this.nlmk_user.lastname,
        password: this.nlmk_user.password,
        start_date: this.getCurrentDate(),
        end_date: null,
        site_id: this.form_site_id,
        email: this.nlmk_user.email,
        profile_id: 3,
        custom_level_id: 0,
        group_id: this.group_id,
        group_id_check: this.group_id_check,
        token: this.token,
        field20_details: {
          cid: this.nlmk_user.field20_details.cid,
          registrenational: this.nlmk_user.field20_details.registrenational,
          datenaissance: this.nlmk_user.field20_details.datenaissance,
          employeur: this.nlmk_user.field20_details.employeur,
          manageremail: this.nlmk_user.field20_details.manageremail,
          limosa: this.nlmk_user.field20_details.limosa,
          e101: this.nlmk_user.field20_details.e101,
          site_user: this.nlmk_user.field20_details.site_user,
          group_id: this.group_id,
        }
      };
      this.formCreatorService.createFormNlmk(body)
        .subscribe(res => {
          if (res.success === true) {
            this.spinner.hide();
            this.nlmk_user.login = '';
            this.nlmk_user.firstname = '';
            this.nlmk_user.lastname = '';
            this.nlmk_user.password = '';
            this.nlmk_user.start_date = '';
            this.nlmk_user.end_date = '';
            this.nlmk_user.site_id = '';
            this.nlmk_user.email = '';
            // @ts-ignore
            this.nlmk_user.profile_id = '';
            // @ts-ignore
            this.nlmk_user.custom_level_id = '';
            this.nlmk_user.field20_details.cid = '';
            this.nlmk_user.field20_details.registrenational = '';
            this.nlmk_user.field20_details.datenaissance = '';
            this.nlmk_user.field20_details.employeur = '';
            this.nlmk_user.field20_details.manageremail = '';

            this.sso_certikap_new(res.login);
          } else {
            this.spinner.hide();
            // Vérifier si l'erreur concerne le domaine email
            if (res.message && res.message.includes('domaine de l\'email')) {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.error'),
                text: res.message || this.runtimeTranslate.instant('alerts.tryAgain')
              });
            }
          }
        }, (err) => {
          this.spinner.hide();
          if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
            (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.invalidEmail'),
              text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
              confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.serverError'),
              text: this.runtimeTranslate.instant('alerts.tryLater'),
            });
          }
          console.log(err);
        });
    }
  }

  //register for form ORIL
  auto_form_registration_ORIL_FR() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.field20_details.employeur === null
      || this.nlmk_user.email === null
      || this.nlmk_user.field20_details.manageremail === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else if (!this.isValidEmail(this.nlmk_user.field20_details.manageremail)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidManagerEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidManagerEmail')
      });
    } else {
      const body = {
        login: this.nlmk_user.login,
        firstname: this.nlmk_user.firstname,
        lastname: this.nlmk_user.lastname,
        password: this.nlmk_user.password,
        start_date: this.getCurrentDate(),
        end_date: null,
        site_id: this.form_site_id,
        email: this.nlmk_user.email,
        profile_id: 3,
        custom_level_id: 0,
        group_id: this.group_id,
        group_id_check: this.group_id_check,
        token: this.token,
        field20_details: {
          cid: this.nlmk_user.field20_details.cid,
          registrenational: this.nlmk_user.field20_details.registrenational,
          datenaissance: this.nlmk_user.field20_details.datenaissance,
          employeur: this.nlmk_user.field20_details.employeur,
          manageremail: this.nlmk_user.field20_details.manageremail,
          limosa: this.nlmk_user.field20_details.limosa,
          e101: this.nlmk_user.field20_details.e101,
          site_user: this.nlmk_user.field20_details.site_user,
          group_id: this.group_id,
        }
      };
      this.formCreatorService.createFormNlmk(body)
        .subscribe(res => {
          if (res.success === true) {
            this.nlmk_user.firstname = '';
            this.nlmk_user.lastname = '';
            this.nlmk_user.email = '';
            this.nlmk_user.field20_details.datenaissance = '';
            this.nlmk_user.field20_details.employeur = '';
            this.nlmk_user.field20_details.manageremail = '';
            this.sso_certikap_new(res.login);
          } else {
            this.spinner.hide();
            // Vérifier si l'erreur concerne le domaine email
            if (res.message && res.message.includes('domaine de l\'email')) {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.error'),
                text: res.message || this.runtimeTranslate.instant('alerts.tryAgain')
              });
            }
          }
        }, (err) => {
          this.spinner.hide();
          if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
            (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.invalidEmail'),
              text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
              confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.serverError'),
              text: this.runtimeTranslate.instant('alerts.tryLater'),
            });
          }
          console.log(err);
        });
    }
  }

  auto_form_registration_ORIL_EN() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.field20_details.employeur === null
      || this.nlmk_user.email === null
      || this.nlmk_user.field20_details.manageremail === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else if (!this.isValidEmail(this.nlmk_user.field20_details.manageremail)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidManagerEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidManagerEmail')
      });
    } else {
      const body = {
        login: this.nlmk_user.login,
        firstname: this.nlmk_user.firstname,
        lastname: this.nlmk_user.lastname,
        password: this.nlmk_user.password,
        start_date: this.getCurrentDate(),
        end_date: null,
        site_id: this.form_site_id,
        email: this.nlmk_user.email,
        profile_id: 3,
        custom_level_id: 0,
        group_id: this.group_id,
        group_id_check: this.group_id_check,
        token: this.token,
        field20_details: {
          cid: this.nlmk_user.field20_details.cid,
          registrenational: this.nlmk_user.field20_details.registrenational,
          datenaissance: this.nlmk_user.field20_details.datenaissance,
          employeur: this.nlmk_user.field20_details.employeur,
          manageremail: this.nlmk_user.field20_details.manageremail,
          limosa: this.nlmk_user.field20_details.limosa,
          e101: this.nlmk_user.field20_details.e101,
          site_user: this.nlmk_user.field20_details.site_user,
          group_id: this.group_id,
        }
      };
      this.formCreatorService.createFormNlmk(body)
        .subscribe(res => {
          if (res.success === true) {
            this.nlmk_user.firstname = '';
            this.nlmk_user.lastname = '';
            this.nlmk_user.email = '';
            this.nlmk_user.field20_details.datenaissance = '';
            this.nlmk_user.field20_details.employeur = '';
            this.nlmk_user.field20_details.manageremail = '';
            this.sso_certikap_new(res.login);
          } else {
            this.spinner.hide();
            // Vérifier si l'erreur concerne le domaine email
            if (res.message && res.message.includes('domaine de l\'email')) {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.error'),
                text: res.message || this.runtimeTranslate.instant('alerts.tryAgain')
              });
            }
          }
        }, (err) => {
          this.spinner.hide();
          if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
            (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.invalidEmail'),
              text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
              confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.serverError'),
              text: this.runtimeTranslate.instant('alerts.tryLater'),
            });
          }
          console.log(err);
        });
    }
  }

  form_AS_SACLAY() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.email === null
      || this.nlmk_user.field20_details.service === null
      || this.nlmk_user.field20_details.employeur === null
      || this.nlmk_user.field20_details.manageremail === null
      || this.nlmk_user.field20_details.numero_installation === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else if (!this.isValidEmail(this.nlmk_user.field20_details.manageremail)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidManagerEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidManagerEmail')
      });
    } else {
      const body = {
        login: this.nlmk_user.login,
        firstname: this.nlmk_user.firstname,
        lastname: this.nlmk_user.lastname,
        password: this.nlmk_user.password,
        start_date: this.getCurrentDate(),
        end_date: null,
        site_id: this.form_site_id,
        email: this.nlmk_user.email,
        profile_id: 3,
        custom_level_id: 0,
        group_id: this.group_id,
        group_id_check: this.group_id_check,
        token: this.token,
        field20_details: {
          cid: this.nlmk_user.field20_details.cid,
          registrenational: this.nlmk_user.field20_details.registrenational,
          datenaissance: this.nlmk_user.field20_details.datenaissance,
          employeur: this.nlmk_user.field20_details.employeur,
          manageremail: this.nlmk_user.field20_details.manageremail,
          limosa: this.nlmk_user.field20_details.limosa,
          e101: this.nlmk_user.field20_details.e101,
          site_user: this.nlmk_user.field20_details.site_user,
          group_id: this.group_id,
          service: this.nlmk_user.field20_details.service,
          numero_installation: this.nlmk_user.field20_details.numero_installation,
        }
      };
      this.formCreatorService.createFormNlmk(body)
        .subscribe(res => {
          if (res.success === true) {
            this.nlmk_user.firstname = '';
            this.nlmk_user.lastname = '';
            this.nlmk_user.email = '';
            this.nlmk_user.field20_details.datenaissance = '';
            this.nlmk_user.field20_details.employeur = '';
            this.nlmk_user.field20_details.manageremail = '';
            this.nlmk_user.field20_details.service = '';
            this.nlmk_user.field20_details.numero_installation = '';
            this.sso_certikap_new(res.login);
          } else {
            this.spinner.hide();
            // Vérifier si l'erreur concerne le domaine email
            if (res.message && res.message.includes('domaine de l\'email')) {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.error'),
                text: res.message || this.runtimeTranslate.instant('alerts.tryAgain')
              });
            }
          }
        }, (err) => {
          this.spinner.hide();
          if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
            (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.invalidEmail'),
              text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
              confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.serverError'),
              text: this.runtimeTranslate.instant('alerts.tryLater'),
            });
          }
          console.log(err);
        });
    }
  }

  form_AS_FONTENAY() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.email === null
      || this.nlmk_user.field20_details.service === null
      || this.nlmk_user.field20_details.employeur === null
      || this.nlmk_user.field20_details.manageremail === null
      || this.nlmk_user.field20_details.numero_installation === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else if (!this.isValidEmail(this.nlmk_user.field20_details.manageremail)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidManagerEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidManagerEmail')
      });
    } else {
      const body = {
        login: this.nlmk_user.login,
        firstname: this.nlmk_user.firstname,
        lastname: this.nlmk_user.lastname,
        password: this.nlmk_user.password,
        start_date: this.getCurrentDate(),
        end_date: null,
        site_id: this.form_site_id,
        email: this.nlmk_user.email,
        profile_id: 3,
        custom_level_id: 0,
        group_id: this.group_id,
        group_id_check: this.group_id_check,
        token: this.token,
        field20_details: {
          cid: this.nlmk_user.field20_details.cid,
          registrenational: this.nlmk_user.field20_details.registrenational,
          datenaissance: this.nlmk_user.field20_details.datenaissance,
          employeur: this.nlmk_user.field20_details.employeur,
          manageremail: this.nlmk_user.field20_details.manageremail,
          limosa: this.nlmk_user.field20_details.limosa,
          e101: this.nlmk_user.field20_details.e101,
          site_user: this.nlmk_user.field20_details.site_user,
          group_id: this.group_id,
          service: this.nlmk_user.field20_details.service,
          numero_installation: this.nlmk_user.field20_details.numero_installation,
        }
      };
      this.formCreatorService.createFormNlmk(body)
        .subscribe(res => {
          if (res.success === true) {
            this.nlmk_user.firstname = '';
            this.nlmk_user.lastname = '';
            this.nlmk_user.email = '';
            this.nlmk_user.field20_details.datenaissance = '';
            this.nlmk_user.field20_details.employeur = '';
            this.nlmk_user.field20_details.manageremail = '';
            this.nlmk_user.field20_details.service = '';
            this.nlmk_user.field20_details.numero_installation = '';
            this.sso_certikap_new(res.login);
          } else {
            this.spinner.hide();
            // Vérifier si l'erreur concerne le domaine email
            if (res.message && res.message.includes('domaine de l\'email')) {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.invalidEmail'),
                text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
                confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: this.runtimeTranslate.instant('alerts.error'),
                text: res.message || this.runtimeTranslate.instant('alerts.tryAgain')
              });
            }
          }
        }, (err) => {
          this.spinner.hide();
          if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
            (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.invalidEmail'),
              text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
              confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.serverError'),
              text: this.runtimeTranslate.instant('alerts.tryLater'),
            });
          }
          console.log(err);
        });
    }
  }

  createUserByForm() {
    const body = {
      login: this.nlmk_user.login,
      firstname: this.nlmk_user.firstname,
      lastname: this.nlmk_user.lastname,
      password: this.nlmk_user.password,
      start_date: this.getCurrentDate(),
      end_date: null,
      site_id: this.form_site_id,
      email: this.nlmk_user.email,
      profile_id: 3,
      custom_level_id: 0,
      group_id: this.group_id,
      group_id_check: this.group_id_check,
      token: this.token,
      field20_details: {
        cid: this.nlmk_user.field20_details.cid,
        registrenational: this.nlmk_user.field20_details.registrenational,
        datenaissance: this.nlmk_user.field20_details.datenaissance,
        employeur: this.nlmk_user.field20_details.employeur,
        manageremail: this.nlmk_user.field20_details.manageremail,
        limosa: this.nlmk_user.field20_details.limosa,
        e101: this.nlmk_user.field20_details.e101,
        site_user: this.nlmk_user.field20_details.site_user,
        group_id: this.group_id,
      }
    };
    this.formCreatorService.createFormNlmk(body)
      .subscribe(res => {
        if (res.success === true) {
          this.spinner.hide();
          this.nlmk_user.login = '';
          this.nlmk_user.firstname = '';
          this.nlmk_user.lastname = '';
          this.nlmk_user.password = '';
          this.nlmk_user.start_date = '';
          this.nlmk_user.end_date = '';
          this.nlmk_user.site_id = '';
          this.nlmk_user.email = '';
          // @ts-ignore
          this.nlmk_user.profile_id = '';
          // @ts-ignore
          this.nlmk_user.custom_level_id = '';
          this.nlmk_user.field20_details.cid = '';
          this.nlmk_user.field20_details.registrenational = '';
          this.nlmk_user.field20_details.datenaissance = '';
          this.nlmk_user.field20_details.employeur = '';
          this.nlmk_user.field20_details.manageremail = '';
          this.sso_certikap_new(res.login);
        } else {
          this.spinner.hide();
          // Vérifier si l'erreur concerne le domaine email
          if (res.message && res.message.includes('domaine de l\'email')) {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.invalidEmail'),
              text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
              confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.error'),
              text: res.message || this.runtimeTranslate.instant('alerts.tryAgain')
            });
          }
        }
      }, (err) => {
        this.spinner.hide();
        if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
          (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.invalidEmail'),
            text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
            confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.serverError'),
            text: this.runtimeTranslate.instant('alerts.tryLater'),
          });
        }
        console.log(err);
      });
  }

  auto_form_registration_basf_lyon() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.field20_details.employeur === null
      || this.nlmk_user.email === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else if (this.nlmk_user.firstname.length === 1 || this.nlmk_user.lastname.length === 1) {
      this.spinner.hide();
      Swal.fire({
        icon: 'question',
        title: this.runtimeTranslate.instant('alerts.confirmShortName'),
        html: '<div style="margin-top: 20px;"></div><span style="font-style: italic;">Can you confirm that your first</span><br/><span style="font-style: italic;">name/surname contain only one letter ?</span>',
        showCancelButton: true,
        confirmButtonText: this.runtimeTranslate.instant('common.yes'),
        cancelButtonText: this.runtimeTranslate.instant('common.no'),
        customClass: {
          confirmButton: 'btn btn-sm btn-primary',
          cancelButton: 'btn btn-sm btn-secondary'
        }
      }).then((result) => {
        if (result.value) {
          // L'utilisateur a cliqué sur "Oui", continuer le traitement
          this.createUserByForm();
        } else {
          // L'utilisateur a cliqué sur "Non", ne rien faire
        }
      });
    } else {
      this.createUserByForm();
    }
  }

  auto_form_registration_lvmh() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.field20_details.employeur === null
      || this.nlmk_user.email === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else if (this.nlmk_user.firstname.length === 1 || this.nlmk_user.lastname.length === 1) {
      this.spinner.hide();
      Swal.fire({
        icon: 'question',
        title: this.runtimeTranslate.instant('alerts.confirmShortName'),
        html: '<div style="margin-top: 20px;"></div><span style="font-style: italic;">Can you confirm that your first</span><br/><span style="font-style: italic;">name/surname contain only one letter ?</span>',
        showCancelButton: true,
        confirmButtonText: this.runtimeTranslate.instant('common.yes'),
        cancelButtonText: this.runtimeTranslate.instant('common.no'),
        customClass: {
          confirmButton: 'btn btn-sm btn-primary',
          cancelButton: 'btn btn-sm btn-secondary'
        }
      }).then((result) => {
        if (result.value) {
          // L'utilisateur a cliqué sur "Oui", continuer le traitement
          this.createUserByForm();
        } else {
          // L'utilisateur a cliqué sur "Non", ne rien faire
        }
      });
    } else {
      this.createUserByForm();
    }
  }

  auto_form_registration_piment() {

    // Forcer l'employeur
    this.nlmk_user.field20_details.employeur = 'GROUPE PIMENT';

    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.email === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else if (this.nlmk_user.firstname.length === 1 || this.nlmk_user.lastname.length === 1) {
      this.spinner.hide();
      Swal.fire({
        icon: 'question',
        title: this.runtimeTranslate.instant('alerts.confirmShortName'),
        html: '<div style="margin-top: 20px;"></div><span style="font-style: italic;">Can you confirm that your first</span><br/><span style="font-style: italic;">name/surname contain only one letter ?</span>',
        showCancelButton: true,
        confirmButtonText: this.runtimeTranslate.instant('common.yes'),
        cancelButtonText: this.runtimeTranslate.instant('common.no'),
        customClass: {
          confirmButton: 'btn btn-sm btn-primary',
          cancelButton: 'btn btn-sm btn-secondary'
        }
      }).then((result) => {
        if (result.value) {
          // L'utilisateur a cliqué sur "Oui", continuer le traitement
          this.createUserByForm();
        } else {
          // L'utilisateur a cliqué sur "Non", ne rien faire
        }
      });
    } else {
      this.createUserByForm();
    }
  }


  auto_form_registration_Forgital() {
    this.spinner.show();
    if (
      this.nlmk_user.lastname === null
      || this.nlmk_user.firstname === null
      || this.nlmk_user.field20_details.datenaissance === null
      || this.nlmk_user.field20_details.employeur === null
      || this.nlmk_user.email === null
    ) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.requiredInputs')
      });
    } else if (!this.isValidEmail(this.nlmk_user.email)) {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.invalidEmailFormat'),
        text: this.runtimeTranslate.instant('alerts.enterValidEmail')
      });
    } else if (this.nlmk_user.firstname.length === 1 || this.nlmk_user.lastname.length === 1) {
      this.spinner.hide();
      Swal.fire({
        icon: 'question',
        title: this.runtimeTranslate.instant('alerts.confirmShortName'),
        html: '<div style="margin-top: 20px;"></div><span style="font-style: italic;">Can you confirm that your first</span><br/><span style="font-style: italic;">name/surname contain only one letter ?</span>',
        showCancelButton: true,
        confirmButtonText: this.runtimeTranslate.instant('common.yes'),
        cancelButtonText: this.runtimeTranslate.instant('common.no'),
        customClass: {
          confirmButton: 'btn btn-sm btn-primary',
          cancelButton: 'btn btn-sm btn-secondary'
        }
      }).then((result) => {
        if (result.value) {
          // L'utilisateur a cliqué sur "Oui", continuer le traitement
          this.createUserByForm();
        } else {
          // L'utilisateur a cliqué sur "Non", ne rien faire
        }
      });
    } else {
      this.createUserByForm();
    }
  }

  // Méthode pour ouvrir la pop-up
  openMulticomptesDialog(multicomptes: any[]) {
    const dialogRef = this.dialog.open(AccountSelectorPopupComponent, {
      width: '600px',
      height: 'auto',  // Hauteur automatique en fonction du contenu
      data: { multicomptes: multicomptes }
    });

    dialogRef.afterClosed().subscribe(selectedCompte => {
      if (selectedCompte) {
        // Si un compte a été sélectionné, tu peux gérer la redirection ici
        this.switchAccount(selectedCompte);
      }
    });
  }

  switchAccount(User: any) {
    this.spinner.show();
    this.loginService.switchAccount(User.login)
      .subscribe(res => {
        if (res.status == 'success') {
          this.spinner.hide();
          localStorage.setItem('profile_id', res.profile_id);
          localStorage.setItem('site_id', res.site_id);
          if (res.profile_id === 10 || res.profile_id === 8) {
            window.location.reload();
            this.router.navigate(['dashboard/inspector']);
            return false;
          }
          window.location.reload();
          this.router.navigate(['dashboard/administrator']);
          return false;
        }
      }, (err) => {
        this.spinner.hide();
        if ((err.error && err.error.message && err.error.message.includes('domaine de l\'email')) ||
          (err.error && typeof err.error === 'string' && err.error.includes('domaine de l\'email'))) {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.invalidEmail'),
            text: this.runtimeTranslate.instant('alerts.invalidEmailDomain'),
            confirmButtonText: this.runtimeTranslate.instant('alerts.editEmail')
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.serverError'),
            text: this.runtimeTranslate.instant('alerts.tryLater'),
          });
        }
        console.log(err);
      });
  }

}
